import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Minimal icon-only back button. Sits in the top-left corner on both desktop
 * and mobile so it visually balances the hamburger on the far-right without
 * fighting the page hero for attention.
 */
function BackButton() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Go back"
      title="Back"
      data-testid="back-button"
      className="fixed top-32 left-3 md:top-36 md:left-4 z-40 h-8 w-8 md:h-9 md:w-9 flex items-center justify-center rounded-full bg-white/70 backdrop-blur border border-[#006847]/30 text-[#006847] shadow-sm hover:bg-white hover:border-[#006847] hover:shadow-md transition"
    >
      <ArrowLeft className="h-4 w-4" />
    </button>
  );
}

export default BackButton;
